import { confirmDialog } from 'primereact/confirmdialog';
import { useTranslation } from 'react-i18next';
import { removePrompt } from '../../services/monitor/prompt/PromptService';

const useRemovePrompt = ({
  refreshAfterDelete,
  loader,
}: {
  refreshAfterDelete: () => void;
  loader: (() => void) | undefined;
}) => {
  const { t } = useTranslation();

  const remove = async (id: number) => {
    if (loader) {
      loader();
    }

    try {
      await removePrompt(id);
      refreshAfterDelete();
    } catch (err) {
      console.error('Error removing prompt:', err);
    }
  };

  const confirmRemove = (id: number) => {
    confirmDialog({
      message: t('areYouSureProceed'),
      header: t('areYouSure'),
      defaultFocus: 'accept',
      accept: () => remove(id),
    });
  };

  return { confirmRemove };
};

export default useRemovePrompt;
